import React from 'react';

interface UnderConstructionProps {
  title?: string;
}

const UnderConstruction: React.FC<UnderConstructionProps> = ({ title = '页面建设中' }) => {
  return (
    <div className="under-construction-container">
      <div className="construction-content">
        <div className="construction-icon">
          <svg viewBox="0 0 128 128" className="crane-icon">
            <path d="M104,40h-4V20h4c2.2,0,4-1.8,4-4s-1.8-4-4-4H24c-2.2,0-4,1.8-4,4s1.8,4,4,4h4v20h-4c-2.2,0-4,1.8-4,4s1.8,4,4,4h4v20h-4
              c-2.2,0-4,1.8-4,4s1.8,4,4,4h4v20h-4c-2.2,0-4,1.8-4,4s1.8,4,4,4h80c2.2,0,4-1.8,4-4s-1.8-4-4-4h-4V76h4c2.2,0,4-1.8,4-4s-1.8-4-4-4
              h-4V48h4c2.2,0,4-1.8,4-4S106.2,40,104,40z M92,96H36V20h56V96z" fill="#1a73e8"/>
            <path d="M64,84c2.2,0,4-1.8,4-4V36c0-2.2-1.8-4-4-4s-4,1.8-4,4v44C60,82.2,61.8,84,64,84z" fill="#1a73e8"/>
            <path d="M52,72c2.2,0,4-1.8,4-4V48c0-2.2-1.8-4-4-4s-4,1.8-4,4v20C48,70.2,49.8,72,52,72z" fill="#1a73e8"/>
            <path d="M76,72c2.2,0,4-1.8,4-4V48c0-2.2-1.8-4-4-4s-4,1.8-4,4v20C72,70.2,73.8,72,76,72z" fill="#1a73e8"/>
          </svg>
        </div>
        <h1>{title}</h1>
        <p className="construction-description">
          我们正在努力为您打造更好的体验！<br />
          敬请期待...
        </p>
        <div className="construction-animation">
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
        </div>
      </div>
      <style>{`
        .under-construction-container {
          min-height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
          background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
          padding: 20px;
        }

        .construction-content {
          text-align: center;
          background: white;
          padding: 40px;
          border-radius: 20px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
          max-width: 500px;
          width: 90%;
          animation: slideUp 0.5s ease-out;
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .construction-icon {
          width: 120px;
          height: 120px;
          margin: 0 auto 30px;
        }

        .crane-icon {
          animation: swing 3s ease-in-out infinite;
          transform-origin: center top;
        }

        @keyframes swing {
          0%, 100% {
            transform: rotate(0deg);
          }
          50% {
            transform: rotate(5deg);
          }
        }

        h1 {
          color: #2c3e50;
          font-size: 2.5em;
          margin-bottom: 20px;
          font-weight: 600;
        }

        .construction-description {
          color: #666;
          font-size: 1.2em;
          line-height: 1.6;
          margin-bottom: 30px;
        }

        .construction-animation {
          display: flex;
          justify-content: center;
          gap: 8px;
          margin-top: 20px;
        }

        .dot {
          width: 8px;
          height: 8px;
          background: #1a73e8;
          border-radius: 50%;
          animation: bounce 1.4s infinite ease-in-out;
        }

        .dot:nth-child(1) {
          animation-delay: -0.32s;
        }

        .dot:nth-child(2) {
          animation-delay: -0.16s;
        }

        @keyframes bounce {
          0%, 80%, 100% {
            transform: scale(0);
          }
          40% {
            transform: scale(1);
          }
        }

        @media (max-width: 480px) {
          .construction-content {
            padding: 30px 20px;
          }

          h1 {
            font-size: 2em;
          }

          .construction-description {
            font-size: 1em;
          }

          .construction-icon {
            width: 100px;
            height: 100px;
          }
        }
      `}</style>
    </div>
  );
};

export default UnderConstruction; 